import { inject, Injectable } from '@angular/core';
import { PlatformService } from '@core/platform';
import { WINDOW } from '@innogy/utils-dom';
import type { DatalayerOutput, GDDLEvent } from '@analytics/models';

@Injectable({
  providedIn: 'root',
})
export class GddlInspectorService implements DatalayerOutput {
  readonly #windowRef = inject(WINDOW);
  readonly platform = inject(PlatformService);
  // Key used to store the event log in sessionStorage.
  readonly #GDDLInspectorEventLogKey = 'eventLog';

  readonly id = 'GDDL_INSPECTOR';

  init() {
    return void 0;
  }

  /**
   * Dispatches a GDDL event to the inspector.
   *
   * @param event - The GDDLEvent object to be logged and dispatched.
   * Appends the event to the sessionStorage log and sends a message to notify listeners.
   */
  public dispatchEvent(event: GDDLEvent) {
    const storage = this.#windowRef.sessionStorage;
    const eventLog = storage.getItem(this.#GDDLInspectorEventLogKey);

    // Appends the serialized event to the existing event log.
    const logWithAppendedEvent = `${eventLog},${JSON.stringify(event)}`;
    storage.setItem(this.#GDDLInspectorEventLogKey, logWithAppendedEvent);

    // Notifies listeners about the analytics event change.
    this.#windowRef.postMessage('analytics-track-change', '*');
  }

  /**
   * Determines whether the output channel can receive events
   * @returns boolean indicating whether or not the output channel should have events forwarded to it.
   */
  public outputConditionsAreMet(): boolean {
    return (
      this.platform.isClient() &&
      typeof this.#windowRef.sessionStorage?.setItem === 'function'
    );
  }
}
